import { useEffect, useRef, useState } from 'react';
import { NavLink } from 'react-router-dom';

import { routes } from '@/config/routes';

import { categoryNavigation, primaryNavigation } from './navigation';

export function DesktopNavigation() {
  const [shopOpen, setShopOpen] = useState(false);
  const shopRef = useRef<HTMLDivElement>(null);
  const shopButtonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    function handlePointer(event: PointerEvent) {
      if (!shopRef.current?.contains(event.target as Node)) setShopOpen(false);
    }

    function handleKey(event: KeyboardEvent) {
      if (event.key === 'Escape') {
        setShopOpen(false);
        shopButtonRef.current?.focus();
      }
    }

    document.addEventListener('pointerdown', handlePointer);
    document.addEventListener('keydown', handleKey);
    return () => {
      document.removeEventListener('pointerdown', handlePointer);
      document.removeEventListener('keydown', handleKey);
    };
  }, []);

  return (
    <nav className="desktop-navigation" aria-label="Primary navigation">
      <div className="shop-menu" ref={shopRef}>
        <button
          className="nav-link nav-link--button"
          ref={shopButtonRef}
          type="button"
          aria-expanded={shopOpen}
          aria-haspopup="menu"
          onClick={() => setShopOpen((open) => !open)}
        >
          Shop <i className="pi pi-angle-down" aria-hidden="true" />
        </button>
        {shopOpen && (
          <div className="shop-menu__panel" role="menu">
            <div className="shop-menu__heading">
              <span>Shop personalized</span>
              <NavLink to={routes.products} onClick={() => setShopOpen(false)}>
                View all
              </NavLink>
            </div>
            {categoryNavigation.map((item) => (
              <NavLink
                className="shop-menu__item"
                key={item.to}
                role="menuitem"
                to={item.to}
                onClick={() => setShopOpen(false)}
              >
                <i className={item.icon} aria-hidden="true" />
                <span>
                  <strong>{item.label}</strong>
                  <small>{item.description}</small>
                </span>
              </NavLink>
            ))}
          </div>
        )}
      </div>
      {primaryNavigation.map((item) => (
        <NavLink className="nav-link" key={item.to} to={item.to}>
          {item.label}
        </NavLink>
      ))}
    </nav>
  );
}
